import { render } from "./LineChart.vue?vue&type=template&id=5038abd0&lang=pug"
import script from "./LineChart.vue?vue&type=script&lang=ts"
export * from "./LineChart.vue?vue&type=script&lang=ts"
script.render = render

export default script